import {useCallback, type ReactNode, AnchorHTMLAttributes} from 'react'
import { openLink } from '@/helpers'

interface ExternalLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string
  children: ReactNode
  useDefaultBrowser?: boolean
}

const ExternalLink = ({
  href,
  children,
  useDefaultBrowser = false,
    ...props
}: ExternalLinkProps) => {
  const handleClick = useCallback((e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    openLink(href, useDefaultBrowser, '_blank')
  }, [href, useDefaultBrowser])

  return (
    <a
      href={href}
      target='_blank'
      rel='noreferrer'
      onClick={handleClick}
      {...props}
    >
      {children}
    </a>
  )
}

export default ExternalLink
